import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: "" as string,
    token: localStorage.getItem("token") || ("" as string),
    targetRoute: {} as object,
    showErrorDialog: false as boolean,
    lastError: {} as object,
    errorSnackbar: false as boolean,
    errorSnackbarMessage: "" as string,
    userDataVersion: 0 as number,
  },
  mutations: {
    setTargetRoute(state, route) {
      state.targetRoute = route || { name: "home" };
    },
    setShowErrorDialog(state, isOpen: boolean) {
      state.showErrorDialog = isOpen;
    },
    setLastError(state, error) {
      state.lastError = error;
    },
    setErrorSnackbar(state, message: string) {
      state.errorSnackbarMessage = message;
      state.errorSnackbar = true;
    },
    clearErrorSnackbar(state) {
      state.errorSnackbar = false;
      state.errorSnackbarMessage = "";
    },
    incrementUserDataVersion(state) {
      state.userDataVersion++;
    },
  },
  actions: {
    async setTargetRoute({ commit }, route) {
      commit("setTargetRoute", route);
    },
    async setShowErrorDialog({ commit }, isOpen) {
      commit("setShowErrorDialog", isOpen);
    },
    async setLastError({ commit }, error) {
      commit("setLastError", error);
    },
    async showErrorSnackbar({ commit }, message: string) {
      commit("setErrorSnackbar", message);
    },
    async notifyUserDataChanged({ commit }) {
      commit("incrementUserDataVersion");
    },
  },
  getters: {
    targetRoute: (state) => state.targetRoute,
    showErrorDialog: (state) => state.showErrorDialog,
    lastError: (state) => state.lastError,
    errorSnackbar: (state) => state.errorSnackbar,
    errorSnackbarMessage: (state) => state.errorSnackbarMessage,
    userDataVersion: (state) => state.userDataVersion,
  },
});
